import BasicList from 'src/features/common/BasicList';
import LeadSummaryView from 'src/features/leads/view/LeadSummaryView';
import { ActivityDialogStore, ActivityHistoryDialogStore, ActivityNotesDialogStore, CadenceListDialogStore, CompanyDialogStore, DailpadPopupStore, DashboardViewStore, FilterSingleLead, HistoryDetailsDialogStore, Lead, LeadActivityCadenceStore, LeadScreenStore, SprintDialogStore, ViewType } from "src/stores/LeadStore"
import { leadEndpoints, optionsEndpoints } from 'src/configs/endpoints';
import { LeadListStore } from 'src/stores/LeadStore'
import { List, PagedList } from 'src/types/common';
import ActivityWorkList from './ActivityWorkList';
import DoActivityAccountLeadDialog from '../leads/view/DoActivityAccountLeadDialog';
import { useEffect, useState } from 'react';
import { client } from '../../utils/axios-client';
import DashboardTodoList from './DashboardTodoList';
import InboundCallList from './InboundCallList';
import DashboardPerformance from './DashboardPerformance';
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { Controller } from 'react-hook-form';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Box from '@mui/material/Box';
import DashboardKPI from './DashboardKPI';
import Divider from '@mui/material/Divider';
import ActivityDashboardList from './ActivityDashboardList';
import { SelectOption } from 'src/types/common';
import TasksToday from './TasksToday';
import DashboardLead from './DashboardLead';
import DashboardActivityChart from './DashboardActivityChart';
import DashboardActivityDonut from './DashboardActivityDonut';
import DashboardAccountPenetrationHeatmap from './DashboardAccountPenetrationHeatmap';
import RenderIf, { ClaimType, ClaimValue } from '../common/RenderIf';
import useOptions from '../../hooks/useOptions';


const Dashboard = () => {
    const { options: activities } = useOptions('activity')    
    const cadenceListDialogMode = CadenceListDialogStore.useState(s => s.cadenceListDialogMode);
    const selectedLead = LeadScreenStore.useState(s => s.selectedLead) as Lead;

    const showTodoList = DashboardViewStore.useState(s => s.showTodoList);
    const showTaskList = DashboardViewStore.useState(s => s.showTaskList);
    const showActivityWorkList = DashboardViewStore.useState(s => s.showActivityWorkList);
    const activityDate = DashboardViewStore.useState(s => s.activityDate);
    const activityWorkListTitle = DashboardViewStore.useState(s => s.activityWorkListTitle);
    const activityName = DashboardViewStore.useState(s => s.activityName);
    //const pageNumber = DashboardViewStore.useState(s => s.pageNumber);
    const showInboundCallList = DashboardViewStore.useState(s => s.showInboundCallList);
    const showPerformanceToday = DashboardViewStore.useState(s => s.showPerformanceToday);
    const showPerformanceThisWeek = DashboardViewStore.useState(s => s.showPerformanceThisWeek);
    const showPerformanceThisMonth = DashboardViewStore.useState(s => s.showPerformanceThisMonth);
    const showDefault = DashboardViewStore.useState(s => s.showDefault);
    const showDetail = DashboardViewStore.useState(s => s.showDetail);
    const showKPIPerformance = DashboardViewStore.useState(s => s.showKPIPerformance);
    const showActivityHistoryList = DashboardViewStore.useState(s => s.showActivityHistoryList);

    const customerId = DashboardViewStore.useState(s => s.customerId);
    const activityType = DashboardViewStore.useState(s => s.activityType);
    const activityHistoryTitle = DashboardViewStore.useState(s => s.activityHistoryTitle);

    const filterSingleLead = FilterSingleLead.useState(s => s.filterSingleLead);

    const [owners, setOwners] = useState([] as SelectOption[]);
    
    useEffect(() => {
        const fetchCadence = async () => {
            const response = await client.get(leadEndpoints.getplaybookcadence.replace('{leadid}', "" + selectedLead?.id.toString()));
            LeadActivityCadenceStore.update(s => { s.record = response.data });
        }
        if (selectedLead != null && cadenceListDialogMode) fetchCadence();
    }, [selectedLead])

   
    const [activityPeriod, setActivityPeriod] = useState<string>('today')

    const handleActivityPeriodChangeChange = (event: SelectChangeEvent) => {
        setActivityPeriod(event.target.value as string);
        switch (event.target.value as string) {
            case 'today':
                DashboardViewStore.update(s => { s.showPerformanceThisMonth = false });
                DashboardViewStore.update(s => { s.showPerformanceThisWeek = false });
                DashboardViewStore.update(s => { s.showPerformanceToday = true });
                break;
            case 'thisweek':
                DashboardViewStore.update(s => { s.showPerformanceThisMonth = false });
                DashboardViewStore.update(s => { s.showPerformanceToday = false });
                DashboardViewStore.update(s => { s.showPerformanceThisWeek = true });
                break;
            case 'thismonth':
                DashboardViewStore.update(s => { s.showPerformanceToday = false });
                DashboardViewStore.update(s => { s.showPerformanceThisWeek = false });
                DashboardViewStore.update(s => { s.showPerformanceThisMonth = true });
                break;
            default:
           
        }
    };

    const [selectedUser, setSelectedUser] = useState<string>('')

    const handleUserChange = (event: SelectChangeEvent) => {
        setSelectedUser(event.target.value as string);
        switch (activityPeriod) {
            case 'today':
                DashboardViewStore.update(s => { s.showPerformanceThisMonth = false });
                DashboardViewStore.update(s => { s.showPerformanceThisWeek = false });
                DashboardViewStore.update(s => { s.showPerformanceToday = true });
                break;
            case 'thisweek':
                DashboardViewStore.update(s => { s.showPerformanceThisMonth = false });
                DashboardViewStore.update(s => { s.showPerformanceToday = false });
                DashboardViewStore.update(s => { s.showPerformanceThisWeek = true });
                break;
            case 'thismonth':
                DashboardViewStore.update(s => { s.showPerformanceToday = false });
                DashboardViewStore.update(s => { s.showPerformanceThisWeek = false });
                DashboardViewStore.update(s => { s.showPerformanceThisMonth = true });
                break;
            default:
            
        }

    };
    

    useEffect(() => {
        const load = async () => {
            var response10 = await client.get(optionsEndpoints.ownerEndpoint);
            setOwners(response10.data);
        };

        load();
    }, [])

    const [isAdmin, setIsAdmin] = useState<boolean>(false); //TODO: pass this from DB for admin view of dashboard

    if (activities.length === 0) return;

    const activityTypeId = activities.find(s => s.name === activityName)?.value ?? '';

    return <div style={{ width: '100%', height: '100%' }}>
        {showDefault &&
            <Grid container spacing={2} justifyContent={'center'} >
                <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.PerformanceComparison}>
                    <Grid item xs={12} md={6}>
                        <FormControl>
                            <InputLabel id="demo-simple-select-label">Performance Comparision (Activity Period)</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={activityPeriod}
                                label="Performance Comparision (Activity Period)"
                                onChange={handleActivityPeriodChangeChange}
                                size='small'
                                sx={{ width: 400 }}
                            >
                                <MenuItem value={'today'}>Today Compared To Yesterday</MenuItem>
                                <MenuItem value={'thisweek'}>This Week Compared To last Week</MenuItem>
                                <MenuItem value={'thismonth'}>This Month Compared To Last Month</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} md={6} justifyContent={'right'}>
                        {isAdmin &&
                            <FormControl>
                                <InputLabel id="demo-simple-select-label2">User</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label2"
                                    id="demo-simple-select"
                                    value={selectedUser}
                                    label="User"
                                    onChange={handleUserChange}
                                    size='small'
                                    sx={{ width: 400 }}
                                >
                                    {owners.map(option => <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>)}
                                </Select>
                            </FormControl>
                        }
                    </Grid>
                </RenderIf>
                <Grid item xs={12} md={9} spacing={2} >
                    <Grid container spacing={2} sx={{ mb: 4 }} >
                        <Grid item xs={12} md={12}>
                            <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.PerformanceComparison}>
                                {showPerformanceToday &&
                                    <DashboardPerformance userId={selectedUser} activityDate={"today"} title={"Performance - Today Compared to Yesterday"} />
                                }
                                {showPerformanceThisWeek &&
                                    <DashboardPerformance userId={selectedUser} activityDate={"thisweek"} title={"Performance - This Week Compared to Last Week"} />
                                }
                                {showPerformanceThisMonth &&
                                    <DashboardPerformance userId={selectedUser} activityDate={"thismonth"} title={"Performance - This Month Compared to Last Month"} />
                                }
                            </RenderIf>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            {showKPIPerformance &&
                                <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.PerformanceKPIs}>
                                    <DashboardKPI userId={selectedUser} />
                                </RenderIf>
                            }
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.ActicityComparison}>
                                <DashboardActivityChart userId={selectedUser} />
                            </RenderIf>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12} md={3} alignItems="flex-start" spacing={2}>
                    <Grid container spacing={2} justifyContent={'center'} sx={{ mb: 4 }}>
                        <Grid item xs={12} sx={{ pt: 2, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }} >
                            {showTodoList &&
                                <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.Workqueue}>
                                    <DashboardTodoList userId={selectedUser} title={"Workqueue"} />
                                </RenderIf>
                            }
                        </Grid>
                        <Grid item xs={12} sx={{ pt: 2, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }} >
                            <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.ActivitySnapshot}>
                                <DashboardActivityDonut userId={selectedUser} />
                            </RenderIf>
                        </Grid>
                        <Grid item xs={12} sx={{ pt: 2, display: 'flex', alignItems: 'left', flexDirection: 'column', mb: 2 }} >
                            <RenderIf claimType={ClaimType.Dashboard} claimValue={ClaimValue.AccountPenetration}>
                                <DashboardAccountPenetrationHeatmap userId={selectedUser} />
                            </RenderIf>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        }
        {showDetail &&
            <Grid container spacing={2} justifyContent={'center'} >
                <Grid item xs={12} md={12} spacing={2} >
                    <Grid item xs={12} md={12}>
                        {showActivityWorkList &&
                            <ActivityWorkList activityDate={activityDate} startDate={""} endDate={""} userId={selectedUser} title={activityWorkListTitle} activityId={activityTypeId} />
                        }
                        {showInboundCallList &&
                            <InboundCallList userId={selectedUser} />
                        }
                        {showActivityHistoryList &&
                            <ActivityDashboardList customerId={customerId} activityDate={activityDate} activityType={activityType} title={activityHistoryTitle} userId={selectedUser} />
                        }
                        {showTaskList &&
                            <TasksToday userId={selectedUser} title="Open Tasks Assigned to You" />
                        }
                        {filterSingleLead &&
                            <DashboardLead />
                        }
                    </Grid>
                </Grid>
            </Grid>    
        }
        
       
    </div>

}

export { Dashboard }

export default Dashboard;